
<span
  class="file-loader-type-text"
  :aria-label="`File type: ${fileType}`"
>
  {{ displayText }}
</span>
